<template>
  <div class="settings-instruction">
    <h2 class="headline">Listing Modal Submit</h2>
    <v-form class="form">
      <v-card class="input">
        <content-editor
          label="Title"
          style="z-index: 10"
          v-model="formData.title"
          @input="$v.formData.title.$touch"
          @blur="$v.formData.title.$touch"
          :error="$v.formData.title"
        />
      </v-card>
      <v-card>
        <content-editor
          label="Content"
          v-model="formData.content"
          @input="$v.formData.content.$touch()"
          @blur="$v.formData.content.$touch()"
          :error="$v.formData.content"
        />
      </v-card>
      <v-btn
        class="btn_submit"
        color="success"
        @click="submitForm"
        :disabled="$v.$invalid || !isWriteAvailable"
      >Update form
      </v-btn>
    </v-form>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  import mixins from '@/utils/mixins'

  export default {
    name: 'SubmitModal',
    mixins: [mixins.isWriteAvailable],
    data () {
      return {
        formData: {
          title: '',
          content: '',
          enabled: false
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'listing:write'
      }
    },
    validations: {
      formData: {
        title: { required },
        content: { required }
      }
    },
    computed: {
      ...mapGetters(['getSubmitModalSettings'])
    },
    watch: {
      getSubmitModalSettings () {
        this.setFormData()
      }
    },
    methods: {
      ...mapActions(['updateForm']),
      setFormData () {
        if (!this.getSubmitModalSettings) return
        this.formData.title = this.getSubmitModalSettings.title || this.formData.title
        this.formData.content = this.getSubmitModalSettings.content || this.formData.content
      },
      submitForm () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.updateForm({
          submitModal: this.formData
        })
      }
    },
    created () {
      this.setFormData()
    }
  }
</script>

<style lang="scss" scoped>
  .input,
  .headline {
    max-width: 480px;
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .headline {
    margin-bottom: 20px;
    text-align: center;
  }

  .card {
    padding: 10px;
    margin-bottom: 15px;
  }

  .btn {
    &_submit {
      margin: 0 auto;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Listing/ListingSettings/submitModal.vue